module.exports = __webpack_public_path__ + "img/album05_21.89123f96.jpg";